export default "__VITE_ASSET__2VHKUg7y__"